import React, { useState } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import theme from './theme';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import AddSupply from './pages/suministros/AddSupply';
import ForgotPassword from './pages/forgotPassword';
import SuministroServicios from './pages/suministros/SuministroServicios';
import PagarFacturas from './pages/facturas/pagarFacturas';
import ConfirmacionPago from './pages/pago/confirmacionPago';
import ErrorPago from './pages/pago/errorPago';
import MisPagos from './pages/pago/mispagos';
import LoginWithoutPassword from './pages/LoginWithoutPassword';

function App() {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const PrivateRoute = ({ children }) => {
    return user ? children : <Navigate to="/login" />;
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout user={user} setUser={setUser}>
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
          <Route
            path="/"
            element={
              user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />
            }
          />
            <Route path="/register" element={<Register setUser={setUser} />} />
            <Route path="/loginsimple" element={<LoginWithoutPassword setUser={setUser} />} />
            <Route path="/forgot-password" element={<ForgotPassword/>} />
            <Route path="/pagoerror/:internalId" element={<ErrorPago  />}/>
            <Route path="/pagoconfirmado/:internalId" element={<ConfirmacionPago  />} />


            <Route path="/dashboard"element={<PrivateRoute> <Dashboard user={user} /></PrivateRoute>}/>
            <Route path="/profile" element={ <PrivateRoute><Profile user={user} /> </PrivateRoute> }/>
            <Route path="/agregarsuministro" element={<PrivateRoute><AddSupply  /></PrivateRoute>} />
            <Route path="/suministro/:id" element= {<PrivateRoute><SuministroServicios /></PrivateRoute>} />
            <Route path="/dashboard/facturaspago" element={<PrivateRoute><PagarFacturas  /></PrivateRoute>} />
            <Route path="/missuministros/facturaspago" element={<PrivateRoute><PagarFacturas  /></PrivateRoute>} />
            <Route path="/dashboard/mispagos" element={<PrivateRoute><MisPagos  /></PrivateRoute>} />


            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
